import { debug, LuxAPI } from "aaa";
import { config } from "config";
import * as cryptoJs from "crypto-js";
import { action, observable } from "mobx";
import { LuxAPIClient } from "network/APIClient";
import { ITrackingData } from "types/tracking";
import authStore from "./AuthStore";
import externalInterfaceStore from "./ExternalInterfaceStore";
import profileStore from "./ProfileStore";

const getTrackingClientID = () => {
    if (externalInterfaceStore.isGeorgeWeb) {
        return "Hybrid_Georgeclient";
    } else if (externalInterfaceStore.isGeorgeApp) {
        return "Hybrid_transactionapp";
    }

    return "unknown";
};

export class TrackingStore {
    @observable productKey?: string;
    @observable pageName: string = "";
    @observable feature: string = "";

    wipe() {
        this.productKey = undefined;
        this.pageName = "";
        this.feature = "";
    }

    sendTrackingInfo = async ({
        event,
        seAction,
        codEventKey,
        data,
        productKey,
    }: {
        event: "page_view" | "digital_action",
        seAction: string,
        codEventKey: string,
        data?: ITrackingData,
        productKey?: string,
    }) => {
        if (config.TRACKING_ENABLED) {
            const profile = profileStore.profile;

            if (!profile || !authStore.accessToken) {
                return;
            }

            try {
                const target = LuxAPI.postLuxTracking({
                    appId: "INT55",
                    codEventKey,
                    codSessionid: cryptoJs.SHA256(authStore.accessToken).toString(),
                    codTouchpoint: getTrackingClientID(),
                    codTrackingId: profile.customerId,
                    event,
                    nameTracker: "George_HYBRID",
                    numBenutzer: profile.userNumber,
                    numMandant: profile.instituteId,
                    seAction,
                    seLabel: productKey ?? this.productKey,
                    seProperty: this.feature,
                    trueTstamp: (new Date()).toISOString(),
                    txtClientId: getTrackingClientID(),
                    vTracker: "1.0.0-hybrid",
                    ...data
                });

                await LuxAPIClient.request(target);
            } catch (error) {
                if (event === "page_view") {
                    debug.log("### error tracking page view");
                } else if (event === "digital_action") {
                    debug.log("### error tracking event");
                }
            }
        }
    }

    @action trackPage = async () => {
        if (config.TRACKING_ENABLED) {
            if (this.pageName) {
                await this.sendTrackingInfo({
                    event: "page_view",
                    codEventKey: this.pageName,
                    seAction: "page_visited"
                });
            }
        }
    }

    @action trackEvent = async ({ eventName, productKey, data }: { eventName: string, productKey?: string, data?: ITrackingData }) => {
        if (config.TRACKING_ENABLED) {
            if (this.pageName) {
                await this.sendTrackingInfo({
                    event: "digital_action",
                    codEventKey: `${this.pageName}_${eventName}`,
                    seAction: eventName,
                    data,
                    productKey
                });
            }
        }
    }
}

const trackingStore = new TrackingStore();
export default trackingStore;


// WEBPACK FOOTER //
// ./src/stores/TrackingStore.ts